import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import * as Analytics from '@angular/fire/analytics'
import { MixPanelService } from './mix-panel.service';
import { Platform } from '@angular/cdk/platform';


@Injectable({
  providedIn: 'root',
})
export class FireAnalyticsService {
  private currentUser: any;
  private fireInstance: any

  constructor(
    private authService: AuthService,
    private mixPanelService: MixPanelService,
    private platform: Platform
  ) {
    if (typeof window !== 'undefined') {
      this.fireInstance = Analytics.getAnalytics()
    }
    this.authService.userProfile.subscribe((res) => (this.currentUser = res));
  }

  setFireBaseUserId(mobileNumber: string) {
    this.mixPanelService.setUserIdentity(mobileNumber)
    if (this.fireInstance) {
      Analytics.setUserId(this.fireInstance, mobileNumber)
    }
  }

  setFirebaseUserProperties() {
    if (this.currentUser && this.currentUser.mobileNumber) {
      const signUpDate = new Date(this.currentUser.date).toDateString();
      const lastLogin = new Date(this.currentUser.updatedAt).toDateString();
      let platform: string = ''
      if (this.platform.isBrowser) {
        if (this.platform.ANDROID) {
          platform = 'Android-Browser'
        } else if (this.platform.IOS) {
          platform = 'IOS-Browser'
        } else {
          platform = 'Browser'
        }
      } else {
        if (environment.app) {
          if (environment.android) {
            platform = 'Android-App'
          } else {
            platform = 'IOS-App'
          }
        } else {
          platform = 'Browser'
        }
      }
      const property = {
        'Mobile Number': this.currentUser.mobileNumber.toString(),
        'User Data ID': this.currentUser.shortId,
        'User Scope': this.currentUser.scope,
        'Email': this.currentUser.email ? this.currentUser.email : '',
        'Sign Up Date': signUpDate,
        'Last Login Date': lastLogin,
        'Name': this.currentUser.name ? this.currentUser.name : `USER_${this.currentUser.sequence}`,
        'Platform': platform
      };
      this.setFireBaseUserId(this.currentUser.mobileNumber.toString())
      if (this.fireInstance) {
        Analytics.setUserProperties(this.fireInstance, property)
      }
      this.mixPanelService.registerUser(property)
    } else {
      this.mixPanelService.registerUser({ 'User Scope': 'Guest' })
      this.setFireBaseUserId('Guest')
    }
  }

  logEvents(eventName: string, properties: any = {}) {
    let property: any = {}
    property = properties
    if (properties.category) {
      property.category = this.allCategories(properties.category)
    }
    if (properties.broker) {
      property.broker = this.allBrokers(properties.broker)
    }

    property.verticalSource = this.verticalType()
    property['User Scope'] = this.currentUser && this.currentUser.scope ? this.currentUser.scope : 'Guest'
    if (typeof window !== 'undefined' && window.sessionStorage.getItem('campaign')) {
      property.campaign = window.sessionStorage.getItem('campaign')
      if (window.sessionStorage.getItem('sai')) {
        property['from_sap'] = true;
      }
      
      if (window.sessionStorage.getItem('rmf')) {
        let _data = JSON.parse(window.sessionStorage.getItem('rmf'));
        property['from_rm'] = true;
        property['rm_journeyType'] = _data.journeyType;
        property['rm_id'] = _data.rmId;
        property['rm_linkId'] = _data.linkId;
      }
    }
    if (Analytics.isSupported() && this.fireInstance) {
      Analytics.logEvent(this.fireInstance, eventName, properties)
    }
    this.mixPanelService.trackEvent(eventName, properties)
  }

  trackScreen(currentScreen: string) {
    Analytics.setCurrentScreen(this.fireInstance, currentScreen)
  }

  private allBrokers(broker: string): string {
    switch (broker) {
      case 'alice_blue':
        return 'Alice Blue';
      case 'master_trust':
        return 'Master Trust';
      case 'trade_smart':
        return 'Trade Smart';
      case 'five_paisa':
        return '5 Paisa';
      case 'zerodha':
        return 'Zerodha';
      case 'klever_trade':
        return 'Klever Trade';
      case 'aditya_birla':
        return 'Aditya Birla';
      case 'nuvama':
        return 'nuvama';
      case 'angel_broking':
        return 'Angel Broking';
      case 'bajaj_finserv':
        return 'Bajaj Finaserv';
      case 'google':
        return 'Google'
      case 'upstox':
        return 'Upstox'
      case 'paytm':
        return 'Paytm'
      case 'other':
        return 'Other'
      default:
        return 'Pickright';
    }
  }

  private allCategories(categories: string): string {
    switch (categories) {
      case 'cash':
        return 'Equity Cash';
      case 'future':
        return 'Equity Future';
      case 'options':
        return 'Equity Options';
      case 'currency_future':
        return 'Currency Future';
      case 'currency_options':
        return 'Currency Options';
      case 'commodity_future':
        return 'Commodity Future';
      case 'commodity_options':
        return 'Commodity Options';
      case 'strategic':
        return 'Strategic';
      default:
        return 'Any';
    }
  }

  private verticalType(): string {
    let verticalName: string = ''
    if (typeof window !== 'undefined') {
      let vertical = window.localStorage.getItem(environment.verticalToken)
      switch (vertical) {
        case 'investment':
          verticalName = 'Investment'
          break;
        case 'trading':
          verticalName = 'Trading'
          break;
        case 'mutual-funds':
          verticalName = 'Mutual Funds'
          break;
        case 'digital-savings':
          verticalName = 'Digital Savings'
          break;
        default:
          verticalName = 'Common'
          break;
      }
    }
    return verticalName
  }


  addPixelFrame(Leadid: any) {
    let iframe = document.createElement('iframe');
    iframe.setAttribute('id', 'pixel-frame');
    iframe.setAttribute('src', `https://track.vcommission.com/pixel?av=677f9e2506a7274d6824d4c5&txn_id=${Leadid}&sub1=${Leadid}`);
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('width', '1');
    iframe.setAttribute('height', '1');
    document.head.appendChild(iframe);
  }

  addTradeCampaignGTM() {
    let scriptHead = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PC7CW23G');`
    let scriptHeadEle = document.createElement('script')
    scriptHeadEle.text = scriptHead
    document.head.appendChild(scriptHeadEle)

    let scriptBody = document.createElement('noScrip')
    let iframe: any = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=GTM-PC7CW23G`
    iframe.width = '0px'
    iframe.height = '0px'
    iframe.setAttribute('style', "display:none;visibility:hidden")
    scriptBody.appendChild(iframe)
    document.body.prepend(scriptBody)
  }
}